import React, { Component } from 'react';

class IconAttachmentPicture extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="21"
                fill="none"
                viewBox="0 0 18 21"
            >
                <path
                    fill="#289FCD"
                    fillRule="evenodd"
                    d="M14.807 17.557H2.572V15.11l3.67-6.117 5.029 6.117 3.536-2.447v4.894zm0-7.953a1.835 1.835 0 11-3.67 0 1.835 1.835 0 013.67 0zm1.64-4.797a17.34 17.34 0 00-1.666-1.906 17.342 17.342 0 00-1.906-1.667C11.89.511 11.411.428 11.137.428H1.654c-.843 0-1.529.686-1.529 1.53v16.517c0 .843.686 1.53 1.53 1.53h14.07c.843 0 1.53-.687 1.53-1.53V6.545c0-.274-.084-.752-.807-1.738zm-2.53-1.04a16.686 16.686 0 011.387 1.555H12.36V2.379c.44.34.97.8 1.556 1.387zm2.114 14.708a.31.31 0 01-.306.306H1.655a.31.31 0 01-.306-.306V1.957a.31.31 0 01.305-.306h9.483v4.283c0 .338.274.611.612.611h4.282v11.93z"
                    clipRule="evenodd"
                ></path>
            </svg>
        );
    }
}

export default IconAttachmentPicture;